import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type FileAssetsDataObject } from 'models/service';

type RenameParams = {
  name: string;
};

export const renameFile = async (fileId: string, data: RenameParams) =>
  apiClient.put<FileAssetsDataObject, ApiClientResponse<FileAssetsDataObject>>(routes.files.update(fileId), data);
